import clsx from "clsx";
import React, { PropsWithChildren } from "react";
import IComponentProps from "../../common/component-props";
import { ITab } from "../tabs";
import styles from "./tab-panel.module.scss";

export interface ITabPanelProps extends IComponentProps {
  tab: ITab;
}

export function TabPanel(props: PropsWithChildren<ITabPanelProps>) {
  if (!props.tab.isActive) {
    return null;
  }

  return (
    <div data-testid={props.testId || "tab-panel"} className={clsx(styles.root, props.className)}>
      {props.children}
    </div>
  );
}